import { ProvideAuth } from './components/auth/useAuth.js';
import useAdminSettings, { ProvideAdminSettings } from './components/auth/useAdminSettings.js';
import PrivateRoute from './components/auth/PrivateRoute.js';
import NavMenu from './components/NavMenu.js';
import Home from './components/Home.js';
import Notice from './components/Notice.js';
import ScrollToTop from './components/ScrollToTop.js';
import theme from './components/theme';
import { SnackbarProvider } from 'notistack';
import { Route, Link, Switch } from 'react-router-dom';
import React, { lazy, useEffect, Suspense } from 'react';
import { CssBaseline, Typography, Button, CircularProgress, AppBar, Toolbar, Box, Container, Grid } from '@material-ui/core';
import { makeStyles, ThemeProvider, StylesProvider } from '@material-ui/core/styles';
import '@fontsource/noto-serif';
import '@fontsource/noto-sans';

import './custom.css';

const Admin = lazy(() => import('./components/admin/Admin.js'));
const Module1 = lazy(() => import('./components/modules/module1/module1.js'));
const Module2 = lazy(() => import('./components/modules/module2/module2.js'));
const Module3 = lazy(() => import('./components/modules/module3/module3.js'));
const Module4 = lazy(() => import('./components/modules/module4/module4.js'));

const useStyles = makeStyles((theme) => ({
    main: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(2)
    }
}));
const App = () => {
    const classes = useStyles();
 
    return (
        <ProvideAuth>
            <ThemeProvider theme={theme}>
                <StylesProvider>
                    <CssBaseline />
                    <NavMenu />
                    <Container maxWidth="lg" className={classes.main}>
                        <ScrollToTop />
                        <SnackbarProvider>
                        <Switch>
                                <PrivateRoute exact path='/' component={Home} />
                                <Route exact path='/ip' component={Notice} />
                                <PrivateRoute path='/diversity'><Suspense fallback={<CircularProgress />}><Module1 /></Suspense></PrivateRoute>
                                <PrivateRoute path='/discrimination'><Suspense fallback={<CircularProgress />}><Module2 /></Suspense></PrivateRoute>
                                <PrivateRoute path='/relationships'><Suspense fallback={<CircularProgress />}><Module3 /></Suspense></PrivateRoute>
                                <PrivateRoute path='/inclusion'><Suspense fallback={<CircularProgress />}><Module4 /></Suspense></PrivateRoute>
                                <PrivateRoute path='/admin/:adminpath?/:moduleID?' isSuperAdmin isInstitutionSuperAdmin isDataDownloadAdmin isRefreshAdmin isFeedbackAdmin><Suspense fallback={<CircularProgress />}>
                                    <ProvideAdminSettings>
                                        <Admin />
                                    </ProvideAdminSettings>
                                </Suspense>
                                </PrivateRoute>
                                <PrivateRoute component={Home} />
                            </Switch>
                        </SnackbarProvider>
                    </Container>
                </StylesProvider>
            </ThemeProvider>
        </ProvideAuth>
    );
};

export default App;
